import React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

interface Props {
  tooltip?: string;
}

const ListingColumnTooltip: React.FC<Props> = ({ tooltip }) => {
  return <TooltipHelp content={tooltip} widthStyle="max" width="220px" />;
};

const RenderedComponent = createReactRenderer({
  component: ListingColumnTooltip,
  selector: '[data-react-root="ListingColumnTooltip"]',
});

history.onChangeState(
  [
    {
      name: undefined,
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
